'use client';
import React from 'react';
import { motion } from 'framer-motion';

const COLORS = {
  ACCENT_GOLD: '#faaf40',
  DARK_BG: '#101010',
  LIGHT_TEXT: '#f0f0f0',
};

const philosophies = [
  { title: 'Mindful Eating', text: 'Slow down and enjoy every bite with awareness. We teach you to listen to your body signals.' },
  { title: 'Balanced Nutrition', text: 'Your plan is built on science, not restriction. We focus on macronutrients that fuel performance.' },
  { title: 'Sustainable Lifestyle', text: 'We help you create habits that last. No crash diets, just a new way of living.' },
];

export default function DietPhilosophySection() {
  return (
    <section
      // Changed py-20 to responsive vertical padding (py-16 on mobile, py-24 on desktop)
      className="relative py-16 sm:py-20 md:py-24"
      style={{
        background: `linear-gradient(to bottom, ${COLORS.DARK_BG}, #1a1a1a)`,
        color: COLORS.LIGHT_TEXT,
      }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          // Responsive Heading: text-3xl (mobile) -> text-5xl (desktop)
          className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-10 sm:mb-16"
        >
          Our <span style={{ color: COLORS.ACCENT_GOLD }}>Philosophy</span>
        </motion.h2>

        {/* Grid: 1 column on mobile, 3 columns on medium screens and up */}
        {/* Gap: smaller gap on mobile (gap-6) to save space, larger on desktop (gap-8/10) */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 lg:gap-10">
          {philosophies.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              // Card Styling:
              // 1. Added border-white/5 for better definition on dark mobile screens
              // 2. Responsive padding: p-6 on mobile, p-8 on desktop
              className="bg-[#181818] rounded-2xl p-6 sm:p-8 shadow-lg border border-white/5 hover:border-[#faaf40]/30 hover:shadow-[0_10px_30px_-10px_rgba(250,175,64,0.15)] transition-all duration-300 group"
            >
              <h3 
                className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 group-hover:scale-105 transition-transform duration-300 origin-center" 
                style={{ color: COLORS.ACCENT_GOLD }}
              >
                {p.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-400 leading-relaxed">
                {p.text}
              </p>
            </motion.div>
          ))}
        </div>
        
      </div>
    </section>
  );
}